export default __webpack_public_path__ + "static/opticus-8a3dd9b15be9471a5a5d36fd87e15ec1.png";